export const THREE_SIXTY_EVALUATION_NAMESPACE = 'threeSixtyEvaluation';

export default {};



// WEBPACK FOOTER //
// ./src/modules/three-sixty-evaluation/store/store.constant.js